
import Typography from '@mui/material/Typography';
import Grid from "@mui/material/Grid";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import IconButton from "@mui/material/IconButton";
import Button from "@mui/material/Button";

function FancyText({ txt, variant, marginTop }) {
  const m = marginTop ? marginTop : "30px";
  const v = variant ? variant : "body1";
  return (
    <Typography
      variant={v}
      sx={{
        mr: 2,
        display: { xs: "flex", md: "flex" },
        fontFamily: '"August Roma Serif"',
        fontWeight: 400,
        letterSpacing: "normal",
        color: "#fff",
        textDecoration: "none",
        alignItems: "center",
        textAlign: "center",
        justifyContent: "center",
        marginTop: m,
        width: "100%"
      }}
    >
      {txt}
    </Typography>
  );
}

function Home() {
  const onClick = () => {
    document.getElementById("test").scrollIntoView({ behavior: "smooth", block: "end", inline: "nearest" });
  };
  const rsvp = () => {
    window.location.href = "/rsvp"
  }
  return (
    <Grid
      container
      rowSpacing={0}
      columnSpacing={{ xs: 1, sm: 2, md: 3 }}
      direction="column"
      justifyContent="center"
      alignItems="center"
      textAlign="center"
    >
      <Grid item xs={1} md={1}>
        <img
          src="home.jpg"
          style={{ maxWidth: "100%", margin: "auto", maxHeight: "100vh" }}
          alt=""
        />
      </Grid>

      <Grid item xs={1} md={1} style={{ marginTop: "-60px" }}>
        <IconButton aria-label="delete" color="primary" onClick={onClick}>
          <KeyboardArrowDownIcon sx={{ fontSize: 50, color: "#fff" }} />
        </IconButton>
      </Grid>

      <Grid item xs={1} md={1} style={{ marginTop: "-30px" }} id="test">
        <FancyText txt="Erica Maglio" variant="h2"/>
        <FancyText txt="&" variant="h4" marginTop={"10px"}/>
        <FancyText txt="Sonny" variant="h2" marginTop={"5px"}/>
        <FancyText txt="Di Michele" variant="h2" marginTop={"5px"}/>
        <span style={{height: "50px", display: "flex"}}>&nbsp;</span>
        <FancyText txt="27/06/2026" variant="h4" />
        <FancyText txt="Sanremo, Italy" variant="h4"/>
        <Button variant="contained" color="secondary" onClick={rsvp} sx={{margin: "40px"}}>RSVP</Button>
      </Grid>
    </Grid>
  );
}

export default Home;
